import { ProductDetail } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface catalogState {
  catalogDetails: ProductDetail | null;
  catalogStatusList: { label: string; value: string }[];
  catalogInventoryStatusList: { label: string; value: string }[];
  loading: boolean;
  error: string | null;
}

const initialState: catalogState = {
  catalogDetails: null,
  catalogStatusList: [],
  catalogInventoryStatusList: [],
  loading: false,
  error: null,
};

const catalogSlice = createSlice({
  name: "catalogInfo",
  initialState,
  reducers: {
    fetchCatalogStart(state) {
      state.loading = true;
      state.error = null;
      state.catalogDetails = null;
    },
    fetchCatalogSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.catalogDetails = action.payload;
    },
    fetchCatalogFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.catalogDetails = null;
    },
    setCatalogStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.catalogStatusList = action.payload;
    },
    setCatalogInventoryStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.catalogInventoryStatusList = action.payload;
    },
    clearCatalog(state) {
      state.catalogDetails = null;
      state.error = null;
    },
  },
});

export const {
  fetchCatalogStart,
  fetchCatalogSuccess,
  fetchCatalogFailed,
  setCatalogStatusList,
  setCatalogInventoryStatusList,
  clearCatalog,
} = catalogSlice.actions;

export default catalogSlice.reducer;
